'use client'

import { useSessionStore } from '@/features/veluvit/stores/session.store'

/**
 * 19+ 작품을 보여 줄지 — 계정 설정(user.settings.showAdult)이 켜져 있고 서버 성인 인증(config.adult.eligible)이 살아 있을 때만.
 * 인증이 만료되면 설정이 켜져 있어도 세이프로 보인다. 세이프 모드는 기기가 아니라 계정을 따라간다(2026-10-07 결정).
 */
export function useShowAdult() {
  return useSessionStore(
    (s) =>
      !!s.data?.user?.settings?.showAdult && !!s.data?.config?.adult?.eligible
  )
}
